'use client';

import { createContext, useContext } from 'react';

export type GeoLocationContextType = {
  countryCode?: string;
};

export const GeoLocationContext = createContext<GeoLocationContextType>({});

export const useGeoLocation = () => useContext(GeoLocationContext);
